<template>
  <div class="app-container">
    <div class="screeBox">
      <el-input
        class="screenInput"
        v-model="screen.like"
        placeholder="请输入车牌号、手机号"
        maxlength="11"
      ></el-input>

      <el-select
        filterable
        class="screenInput"
        v-model="screen.status"
        placeholder="请选择付款状态"
        style="margin-right: 10px"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item.title"
          :value="item.id"
          v-for="(item, index) in statusList"
          :key="index"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="(screen.page = 1), fetchData()"
        >搜索</el-button
      >
      <el-button type="primary" plain @click="reset()">重置</el-button>
    </div>
    <div style="margin-top: 20px">
      <el-button
        size="medium"
        type="warning"
        @click="derive()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/carport/coupon_order_export')"
        >导出</el-button
      >
    </div>
    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <!-- <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column> -->
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="订单编号" width="300">
        <template slot-scope="scope">
          <span>{{ scope.row.order_no }}</span>
        </template>
      </el-table-column>
      <el-table-column label="优惠券名称">
        <template slot-scope="scope">
          <span>{{ scope.row.tpl_json ? scope.row.tpl_json.title : "" }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="所属企业" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.company ? scope.row.company.name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="缴费类型" width="120">
        <template slot-scope="scope">
          <span>{{
            scope.row.renew_type == 1
              ? "包月申请缴费"
              : scope.row.renew_type == 2
              ? "包月续费"
              : scope.row.renew_type == 3
              ? "临时停车缴费"
              : ""
          }}</span>
        </template>
      </el-table-column> -->

      <el-table-column label="所属用户">
        <template slot-scope="scope">
          <span>{{ scope.row.user ? scope.row.user.name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="购买数量" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.number }}</span>
        </template>
      </el-table-column>

      <el-table-column label="订单价格" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column label="订单状态" width="120">
        <template slot-scope="scope">
          <span>{{
            scope.row.status == 1
              ? "待付款"
              : scope.row.status == 2
              ? "付款成功"
              : scope.row.status == 3
              ? "付款失败"
              : scope.row.status == 4
              ? "取消支付"
              : "已退款"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="付款时间">
        <template slot-scope="scope">
          <span>{{ scope.row.order ? scope.row.order.pay_time : "" }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="是否开票" width="120">
        <template slot-scope="scope">
          <span>{{
            scope.row.is_invoce == 0
              ? "未开票"
              : scope.row.is_invoce == 1
              ? "已开票"
              : ''
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="付款时间" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.pay_time ? scope.row.pay_time : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="承租开始时间" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.start_time }}</span>
        </template>
      </el-table-column>
      <el-table-column label="承租结束时间" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.end_time }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="examine(scope.row.id)"
            v-if="
              roles.includes('/carport/order_refund') &&
              scope.row.pay_status == 2 &&  scope.row.actual_receipt != 0 &&  scope.row.is_invoce == 0
            "
            >退款</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { openPark } from "@/api/index";
import {
  orderList,
  applyDel,
  order_refund,
  coupon_order_export,
  get_coupon_record,
} from "@/api/parking";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      list: [],
      listLoading: true,
      statusList: [
        {
          title: "待付款",
          id: 1,
        },
        {
          title: "付款成功",
          id: 2,
        },
        {
          title: "付款失败",
          id: 3,
        },
        {
          title: "取消支付",
          id: 4,
        },
        {
          title: "已退款",
          id: 5,
        },
      ],
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
      },
      total: 0,
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      form: {
        id: "",
        status: "",
        reason: "",
      },
      rules: {
        status: [{ required: true, message: "请选择审核", trigger: "change" }],
        reason: [
          { required: true, message: "请输入驳回意见", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    // this.getPark();
  },
  methods: {
    // 导出
    derive() {
      let data = {
        park_id: this.screen.park_id,
        like: this.screen.like,
        status: this.screen.status,
      };
      console.log(data);
      // return
      const loading = this.$loading({
        lock: true,
        text: "数据量过大，正在导出中...",
        spinner: "el-icon-loading",
      });
      coupon_order_export(data)
        .then((res) => {
          loading.close();
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel;charset=utf-8",
          });
          // let fileName = decodeURI(res.headers.content-disposition).replace(/attachment;filename=/, '')

          let downloadElement = document.createElement("a");
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = res.name;
          // downloadElement.target="_blank"
          downloadElement.setAttribute("target", "_blank");
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((error) => {
          loading.close();
        });
    },
    examine(id) {
      this.$confirm("此操作将退款, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          order_refund({ order_id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除",
          // });
        });
    },
    reset() {
      this.screen = {
        park_id: "",
        page: 1,
        page_size: 15,
        like: "",
        status: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          applyDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      get_coupon_record(this.screen).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
</style>
